import { render, staticRenderFns } from "./AssetSearch.vue?vue&type=template&id=dded8382&scoped=true"
import script from "./AssetSearch.vue?vue&type=script&lang=js"
export * from "./AssetSearch.vue?vue&type=script&lang=js"
import style0 from "./AssetSearch.vue?vue&type=style&index=0&id=dded8382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dded8382",
  null
  
)

export default component.exports